var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllsetraTriangles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 40,
    viewBox: "0 0 96 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 40L3.62435 0H47.1166L0 40Z",
    fill: "#00E2D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9938 40L47.0712 0H96L42.9938 40Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllsetraTriangles);
export default __webpack_public_path__ + "static/media/allsetra-triangles.6108d2853cdcadf4370b63f64fdfc72f.svg";
export { ForwardRef as ReactComponent };